import { Dialog } from '@ori-ui/components';
import { styled, Typography, useMediaQuery, useTheme } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { useContext, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Pages } from './pages';
import { localization } from '~/shared/constants';
import { stateContext, wizardContext } from '~/shared/contexts';

const ContentWrap = styled('div')(({ theme }) => ({
  minWidth: 200,
  [theme.breakpoints.up('md')]: {
    width: 400,
  },
}));

const ModalHeader = styled(Typography)(({ theme }) => ({
  margin: 0,
  padding: 0,
  marginBottom: theme.spacing(3),
}));

const steps = [1, 2, 3];

export function AutoshipWizard() {
  const { getTestIdProps } = useTestId();
  const { open, onClose } = useContext(wizardContext);
  const { isBackEnabled, stepBack, currentStep } = useContext(stateContext);
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.only('xs'));

  const CurrentPage = useMemo(() => Pages[currentStep], [currentStep]);

  const headingKey = useMemo(() => {
    if (currentStep < steps.length) {
      return 'newSubscription';
    }

    return 'subscriptionReview';
  }, [currentStep]);

  return (
    <Dialog
      {...getTestIdProps(`autoship-wizard`)}
      header={
        <ModalHeader variant="h4">
          <FormattedMessage
            id={headingKey}
            defaultMessage={localization[headingKey]}
          />
        </ModalHeader>
      }
      sx={{
        '& .MuiOriDialog-content': { ...(!isMobile && { overflow: 'initial' }) }, // disable default scroll on Dialog content
        '& .MuiOriDialogBase-dialogGrid': { ...(isMobile && { top: '60px' }) },
      }}
      showBackButton={isBackEnabled}
      open={open}
      onBack={stepBack}
      onClose={onClose}
    >
      <ContentWrap>{typeof CurrentPage === 'function' ? <CurrentPage /> : <div />}</ContentWrap>
    </Dialog>
  );
}
